export const GET_TEAMS = 'GET_TEAMS';
